import actionTypes from "./actionTypes";
import * as filesUtils from "../utils/filesUtils";

const geUserManualRequest = () => ({
  type: actionTypes.GET_USER_MANUAL_REQUEST,
});
const getUserManualSuccess = (res) => ({
  type: actionTypes.GET_USER_MANUAL_SUCCESS,
  res,
});
const getUserManualFailure = (error) => ({
  type: actionTypes.GET_USER_MANUAL_FAILURE,
  error,
});
export const getUserManual = () => {
  return async (dispatch) => {
    try {
      dispatch(geUserManualRequest());
      let res = await filesUtils.getUserManual();
      dispatch(getUserManualSuccess(res));
    } catch (error) {
      dispatch(getUserManualFailure(error));
    }
  };
};


const getAdminManualRequest = () => ({
  type: actionTypes.GET_ADMIN_MANUAL_REQUEST,
});
const getAdminManualSuccess = (res) => ({
  type: actionTypes.GET_ADMIN_MANUAL_SUCCESS,
  res,
});
const getAdminManualFailure = (error) => ({
  type: actionTypes.GET_ADMIN_MANUAL_FAILURE,
  error,
});
export const getAdminManual = () => {
  return async (dispatch) => {
    try {
      dispatch(getAdminManualRequest());
      let res = await filesUtils.getAdminManual();
      dispatch(getAdminManualSuccess(res));
    } catch (error) {
      dispatch(getAdminManualFailure(error));
    }
  };
};

const getReportsNamesRequest = () => ({
  type: actionTypes.GET_REPORTS_NAMES_REQUEST,
});
const getReportsNamesSuccess = (res) => ({
  type: actionTypes.GET_REPORTS_NAMES_SUCCESS,
  res,
});
const getReportsNamesFailure = (error) => ({
  type: actionTypes.GET_REPORTS_NAMES_FAILURE,
  error,
});
export const getReportsNames = () => {
  return async (dispatch) => {
    try {
      dispatch(getReportsNamesRequest());
      let res = await filesUtils.getReportsNames();
      dispatch(getReportsNamesSuccess(res));
    } catch (error) {
      dispatch(getReportsNamesFailure(error));
    }
  };
};

const downloadFileRequest = () => ({
  type: actionTypes.DOWNLOAD_FILE_REQUEST,
});
const downloadFileSuccess = () => ({
  type: actionTypes.DOWNLOAD_FILE_SUCCESS,
});
const downloadFileFailure = (error) => ({
  type: actionTypes.DOWNLOAD_FILE_FAILURE,
  error,
});
export const downloadReport = (reportName, I_AG_ZIADOST, inPDF = false) => {
  return async (dispatch) => {
    try {
      dispatch(downloadFileRequest());
      await filesUtils.downloadReport(reportName, I_AG_ZIADOST, inPDF);
      dispatch(downloadFileSuccess());
    } catch (error) {
      dispatch(downloadFileFailure(error));
    }
  };
};
export const downloadPriloha = (I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE) => {
  return async (dispatch) => {
    try {
      dispatch(downloadFileRequest());
      await filesUtils.downloadPriloha(I_AG_ZIAD_BIN, FILE_NAME, L_VYJADRENIE);
      dispatch(downloadFileSuccess());
    } catch (error) {
      dispatch(downloadFileFailure(error));
    }
  };
};
